import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@gemini/ui';
import { isServer } from '@/utils/isServer';
export const ObfuscatedButtonLink = ({ children, ...props }) => {
    if (!isServer() && window?.isUser) {
        return _jsx(Button, { ...props, children: children });
    }
    return _jsx(Button, { children: children });
};
